import { render, staticRenderFns } from "./componentTextarea.vue?vue&type=template&id=2e649f3e&scoped=true&"
import script from "./componentTextarea.vue?vue&type=script&lang=ts&"
export * from "./componentTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./componentTextarea.vue?vue&type=style&index=0&id=2e649f3e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e649f3e",
  null
  
)

export default component.exports